import React from "react";
import { Box } from "@mui/material";
import RatesChart from "./RatesChart";
export default function InterBankRates() {
  return (
    <Box>
      <RatesChart yearValue={1} />
    </Box>
  );
}
